<template>
  <div v-if="visible">
    <slot name="content"></slot>
  </div>
</template>

<script>
  'use strict'
  
  import api from 'config/api'

  export default {

    name: 'VisibleFor',

    props: api.roles,

    data: () => ({
      visible: false,
      userRol: null
    }),

    created () {
      this.userRol = this.$store.getters['api/getUserRol']
      this.checkUserPrivileges()
    },

    methods: {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      checkUserPrivileges () {
        this.visible = typeof this.$props[this.userRol] !== 'undefined'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/vue-user/visible-for.vue